import React from 'react';

export const CheckboxInput = (props) => {
  const {
    margin,
    id,
    name,
    value,
    checked,
    disabled,
    handleInput,
    label,
  } = props;

  return (
    <div className={`checkbox-wrapper ${margin ? margin : ''}`}>
      <input
        type="checkbox"
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={(e) => {
          if (handleInput) {
            handleInput(e.target.value, e.target.checked);
          }
        }}
      />
      <label
        htmlFor={id}
        className={`checkbox-wrapper ${margin ? margin : ''}`}
      >
        {label}
      </label>
    </div>
  );
};
